(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["val-brand-header"] && !Shopify.designMode) return;
  try {
    const valFeedback = document.querySelector('[data-val-cart-feedback]');
if (valFeedback) {
  const counts = () => document.querySelectorAll('[data-val-cart-count]');
  const renderCount = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    counts().forEach((node) => { node.textContent = String(count); });
  };
  let revision = 0;
  document.addEventListener('shopify:cart:lines-update', (event) => {
    const current = ++revision;
    if (!event.promise) return;
    event.promise.then(({ cart, detail, userErrors }) => {
      if (current !== revision) return;
      renderCount(cart?.totalQuantity);
      if (detail?.didError || userErrors?.length) return;
      valFeedback.hidden = event.action !== 'add';
    }).catch(() => {});
  });
  valFeedback.querySelector('[data-val-cart-dismiss]').addEventListener('click', () => {
    valFeedback.hidden = true;
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    valFeedback.hidden = true;
    const current = ++revision;
    fetch(valFeedback.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then((cart) => {
        if (current === revision) renderCount(cart.item_count);
      })
      .catch(() => {});
  });
}
  } catch(e) { console.error(e); }
})();

})();
